import { METHOD } from './method'

export const API_INTERNAL_MOVEMENT = {
    LIST: {
        api: '/v1/hr-adm/hr-metrics/internal-movements',
        method: METHOD.POST,
    },
    PREVIEW: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/history',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/export',
        method: METHOD.POST,
    },

    DOWNLOAD_TEMPLATE: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/import/download-template',
        method: METHOD.GET,
    },
    FILE_VALIDATION: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/import/validate',
        method: METHOD.POST,
    },
    IMPORT: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/import/process',
        method: METHOD.POST,
    },

    LIST_DEPARTMENT: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/job-units/department',
        method: METHOD.POST,
    },
    LIST_DIVISION: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/job-units/division',
        method: METHOD.POST,
    },
    LIST_GRADE: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/grades',
        method: METHOD.POST,
    },
    LIST_CHANGE_TYPE: {
        api: '/v1/hr-adm/hr-metrics/internal-movements/change-types',
        method: METHOD.GET,
    },
}
